import PropTypes from 'prop-types';
import styles from './FJProfileList.module.less';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJConfig from '../../../config/FJConfig.js';
const profileList = [
    {
        id: 'default',
    },
    {
        id: 'boy',
    },
    {
        id: 'girl',
    },
    {
        id: 'man',
    },
    {
        id: 'woman',
    },
    {
        id: 'elderlyman',
    },
    {
        id: 'elderlywoman',
    },
];

const FJProfileList = props => {
    const { value, onChange } = props;
    return (
        <div className={styles.box}>
            {profileList.map((item, index) => {
                return (
                    <div
                        className={styles.item}
                        key={index}
                        onClick={() => {
                            onChange(item.id);
                        }}
                    >
                        <FJHoverBoardGradation active={item.id === value} borderRadius={22} isShowInBorder={true}>
                            <img
                                className={styles.img}
                                src={FJConfig.profilePath ? FJConfig.profilePath + item.id + '.png' : null}
                                alt=''
                            />
                        </FJHoverBoardGradation>
                    </div>
                );
            })}
        </div>
    );
};

FJProfileList.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};
export default FJProfileList;
